// extracted by mini-css-extract-plugin
export var promotionLink = "_vz-0";